// Tags the GA session with the authenticated user's Entra object id (GUID).
// Never sends email or display name — those are PII under GA's terms.

import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { setUserId, clearUserId } from './analytics';

const UserIdentifier = () => {
  const { accounts } = useMsal();
  const oid = accounts[0]?.localAccountId || null;

  useEffect(() => {
    if (oid) {
      setUserId(oid);
    } else {
      clearUserId();
    }
  }, [oid]);

  return null;
};

export default UserIdentifier;
